module.exports = __webpack_public_path__ + "img/alert-outline.4f3917c.svg";